export default "__VITE_ASSET__17d02c1d__"